import {constants} from '@neosvoc/nv-platform-core-common';
import multipleChoice1ToSingleChoice1 from './multipleChoice1ToSingleChoice1';
import singleChoice1ToMultipleChoice1 from './singleChoice1ToMultipleChoice1';
// import battery1ToBattery2 from './battery1ToBattery2';
// import battery2ToBattery1 from './battery2ToBattery1';

const converters = {
    [constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_1]: {
        [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1]: multipleChoice1ToSingleChoice1,
    },
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1]: {
        [constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_1]: singleChoice1ToMultipleChoice1,
    },
    /*
    [constants.EDITOR_TEMPLATES.BATTERY_1]: {
        [constants.EDITOR_TEMPLATES.BATTERY_2]: battery1ToBattery2,
    },
    [constants.EDITOR_TEMPLATES.BATTERY_2]: {
        [constants.EDITOR_TEMPLATES.BATTERY_1]: battery2ToBattery1,
    },
    */
};

export default converters;
